module.exports = __webpack_public_path__ + "img/xsj-log3-4.d8b8ad49.png";